/* eslint-disable quote-props, max-len */

export default {
  'season': ({ seasonNumber }) => `Temporada ${seasonNumber}`,
  'episode': ({ episodeNumber }) => `Episodio ${episodeNumber}`,
  'parentalControl.enterPin': 'Introduce el código PIN para ver este contenido protegido',
  'adInfo': ({ ads, adsCount }) => `Anuncio ${ads} de ${adsCount}`,
  'visitAd': 'Sitio del anunciante',
  'skipAd': 'Saltar',
  'skipAdInTime': ({ time }) => `Saltar en ${time}`,
  'chromecast.castingTo': 'Transmitir a',
  'chromecast.onboardingLabel': 'Transmitir a tu TV',
  'playerSettings.audio': 'Audio',
  'playerSettings.subtitles': 'Subtítulos',
  'playerSettings.quality': 'Calidad',
  'playerSettings.off': 'Desactivados',
  'playerSettings.auto': 'Automático',
  'playerSettings.high': 'Alta',
  'playerSettings.medium': 'Media',
  'playerSettings.low': 'Baja',
  'playerError.noSubscription': 'Actualiza tu suscripción para poder ver este contenido',
  'playerError.countryPermission': 'El contenido no está disponible en tu país',
  'playerError.trafficOverload': 'Estamos experimentando problemas en el tráfico, por favor inténtalo más tarde',
  'playerError.upgradeSubscription': 'Actualiza tu suscripción para poder ver este canal',
  'playerError.notAvailable': 'Disculpa, este video no está disponible',
  'playerError.noLongerAvailable': 'Disculpa, el contenido  ya no está disponible',
  'playerError.anotherPlayer': 'Al parecer tienes la aplicación abierta en otro video player',
  'playerError.verifyEmail': 'Verifica tu correo para ver el contenido',
  'playerError.parentalControl': 'El control parenta está activado. No puedes acceder a este contenido.',
  'playerError.wrongPIN': 'Código PIN incorrecto. Inténtalo de nuevo.',
  'playerError.cannotChromecast': 'Chromecast no está disponible para ver el contenido',
  'playerError.tooManyDevices': 'Tu lista de dispositivos registrados está llena. Puedes resetear tú lista en ajustes de tu cuenta.',
  'playerError.enterPostcode': 'Ingrese tu código postal',
  'playerError.wrongRegion': 'Este programa no está disponible en tú país',
  'playerError.noDRM': 'No podemos mostrar este contenido debido a que tiene restricciones legales y no puede ser distribuido en este dispositivo',
  'playerError.noLiveRights': 'Este contenido en directo no está disponible para este programa',
  'playerError.browser': 'Su navegador no puede leer el contenido. Intente reinstalar su navegador o utilizar uno diferente.',
  'playerError.adblockerDetected': 'Desactiva tu adblocker o revisa tu conexión de internet',
  'playerError.entitlementUnauthorized': 'La sesión ha caducado. Prueba otra vez, desconectándote e iniciando sesión de nuevo.',
  'playerError.forbiddenProxy': 'Los videos no se pueden ver si usas un Proxy o un VPN',
  'playerError.licenseRejected': 'Due to license restrictions, this channel is not supported on this browser.',
  'playerError.outputRestricted': 'Due to license restrictions, playback is not supported on this display.',
  'playerError.serverError': ({ code }) => `Solicitud de red fallida, código de estado ${code}. Por favor, inténtelo de nuevo.`,
  'playerError.networkError': 'Solicitud de red fallida, pero no en el servidor. Por favor, inténtelo de nuevo.',
  'playerOverlays.pauseOverlay': 'Reanudar la reproducción le llevará al punto del programa en directo',
  'error': 'Ha ocurrido un error. Inténtalo de nuevo.',
  'nextVideo.label': 'Siguiente episodio',
  'nextVideo.timer': ({ time }) => `en ${time}`,
  'nextVideo.watchCredits': 'Ver créditos',
};
